App.addModule(function(app) {

    if (!app.getConfigFlag('pinterest/tracking/active') || !app.getConfig('pinterest/tracking/tag_id')) {
        return
    }

    app.onConsent('performance', () => {

        window.pintrk = function () {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))
        }

        pintrk.queue = []
        pintrk.version = "3.0"

        app.loadScript('https://s.pinimg.com/ct/core.js')

        pintrk('load', app.getConfig('pinterest/tracking/tag_id'))

        pintrk('page')

        const order = app.get('checkout.order')

        if (order) {
		    
		    const items = []
            
            let total_qty = 0

		    Object.values(order.items).forEach(item => {

                items.push({
            		product_name: item.product.name,
            		product_id: item.sku,
            		product_quantity: item.qty_ordered,
            		product_price: app.round(item.base_price, 2)
            	})

                total_qty+= item.qty_ordered
        	})
		    
        	pintrk('track', 'checkout', {
                event_id: order.increment_id,
                value: app.round(order.base_subtotal, 2),
                order_id: order.increment_id,
                order_quantity: total_qty,
                currency: order.base_currency_code,
                line_items: items
            })
	    }
    })
})
